import { render, staticRenderFns } from "./MasterButtom.vue?vue&type=template&id=6e25b941&scoped=true&"
import script from "./MasterButtom.vue?vue&type=script&lang=js&"
export * from "./MasterButtom.vue?vue&type=script&lang=js&"
import style0 from "./MasterButtom.vue?vue&type=style&index=0&id=6e25b941&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e25b941",
  null
  
)

export default component.exports